"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAnchor = void 0;
var _Anchor = require("./Anchor");
// TODO: in v9, move styled() from Anchor.jsx to here
var StyledAnchor = _Anchor.Anchor;
exports.StyledAnchor = StyledAnchor;